import axios from "@/app/Axios";

class mesas {
    async saveMesas(data) {
        try {
            console.log("Respuesta de Servicio ", data);
            const response = await axios.post("/post_mesas", data);
            console.log("Respuesta de Servicio ", response);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
    async getmesas() {
        try {
          const response = await axios.get("/get_mesas");
          return response.data;
        } catch (error) {
          console.log(error);
          return { status: false, message: "Error interno del servidor" };
        }
      }
      async getmesasdetalle() {
        try {
          const response = await axios.get("/detalle");
          return response.data;
        } catch (error) {
          console.log(error);
          return { status: false, message: "Error interno del servidor" };
        }
      }

}
export default mesas;
